export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const idtify = (id: string): string => {
  return id.toLowerCase().replace(/[\\./]/gm, "_");
};

